<template>
  <div id="settingsTakeout">
    <Tabs>

      <TabSection :title="$t('settings.general')" v-if="config.takeout" class="general">
        <div class="columns">
          <div class="column">
            <div class="group">
              <label>{{$t("settings.delay")}}</label>
              <input type="number" v-model="config.takeout.general.averageDelay">
            </div>
            <div class="group" v-if="permissions.tipsActivated">
              <div class="subtitle">{{$t('settings.tip')}}</div>
              <TipBox no-border info>
                <span v-html="$t('tips.tip')"></span>
              </TipBox>
              <label>{{$t("settings.tip")}}</label>
              <select v-model="config.takeout.general.tipsActivated">
                <option :value="true">{{$t('yes')}}</option>
                <option :value="false">{{$t('no')}}</option>
              </select>
            </div>
            <div class="subtitle">
              <span class="flex-grow">{{$t("settings.service_fee")}}</span>
            </div>
            <TipBox info no-border>
              <span v-html="$t('tips.service_fees')"></span>
            </TipBox>
            <div class="group">
              <label>{{$t("settings.amount")}} ({{currencySymbol}})</label>
              <input type="number" v-model="config.takeout.general.serviceFees.amount">
            </div>
          </div>
          <div class="column">
            <div class="subtitle">
              <span class="flex-grow">{{$t("settings.order_amount")}}</span>
            </div>
            <TipBox danger no-border>
              <span v-html="$t('tips.minimum_amount')"></span>
            </TipBox>
            <div class="columns">
              <div class="column group">
                <label>{{$t("settings.minimum_amount")}} ({{currencySymbol}})</label>
                <input type="number" v-model="config.takeout.general.minimumPrice">
              </div>
              <!-- <div class="column group">
                <label>{{$t("settings.maximum_amount")}} ({{currencySymbol}})</label>
                <input type="number" v-model="config.takeout.general.maximumPrice">
              </div> -->
            </div>
            <div class="subtitle">
              <!-- <span class="flex-grow">{{$t("settings.order_clients")}}</span> -->
            </div>
            <div class="columns">
              <!-- <div class="column group">
                <label>{{$t("settings.minimum_clients")}}</label>
                <input type="number" v-model="config.takeout.general.minimumMeals">
              </div> -->
              <!-- <div class="column group">
                <label>{{$t("settings.maximum_clients")}}</label>
                <input type="number" v-model="config.takeout.general.maximumMeals">
              </div> -->
            </div>
          </div>
        </div>
      </TabSection>
  
      <TabSection :title="$t('open_hours')" v-if="cascader && config.takeout">
        <TipsOpenHours />
        <div id="editOpenHoursContainerTakeout" class="group">
          <input id="editOpenHoursTakeout" type="checkbox" v-model="config.takeout.editOpenHours">
          <label for="editOpenHoursTakeout">{{$t("settings.edit_open_hours")}}</label>
        </div>
        <div class="columns" :class="{openHoursDisabled: !config.takeout.editOpenHours}">
          <div class="column">
            <DayTimeRange :day="cascader.get('takeout.hours.monday').value" dayName="monday" context="takeout"
                          errorsKey="config.takeout.hours.monday.hours" :validate="parentValidate"></DayTimeRange>
            <DayTimeRange :day="cascader.get('takeout.hours.tuesday').value" dayName="tuesday" context="takeout"
                          errorsKey="config.takeout.hours.tuesday.hours" :validate="parentValidate"></DayTimeRange>
            <DayTimeRange :day="cascader.get('takeout.hours.wednesday').value" dayName="wednesday" context="takeout"
                          errorsKey="config.takeout.hours.wednesday.hours" :validate="parentValidate"></DayTimeRange>
            <DayTimeRange :day="cascader.get('takeout.hours.thursday').value" dayName="thursday" context="takeout"
                          errorsKey="config.takeout.hours.thursday.hours" :validate="parentValidate"></DayTimeRange>
          </div>
          <div class="column">
            <DayTimeRange :day="cascader.get('takeout.hours.friday').value" dayName="friday" context="takeout"
                          errorsKey="config.takeout.hours.friday.hours" :validate="parentValidate"></DayTimeRange>
            <DayTimeRange :day="cascader.get('takeout.hours.saturday').value" dayName="saturday" context="takeout"
                          errorsKey="config.takeout.hours.saturday.hours" :validate="parentValidate"></DayTimeRange>
            <DayTimeRange :day="cascader.get('takeout.hours.sunday').value" dayName="sunday" context="takeout"
                          errorsKey="config.takeout.hours.sunday.hours" :validate="parentValidate"></DayTimeRange>
          </div>
        </div>
      </TabSection>
  
      <TabSection :title="$t('settings.order_in_advance')" v-if="config.takeout">
        <TipsInAdvance />
        <div id="activateInAdvanceContainerTakeout" class="group">
          <input id="activateInAdvanceTakeout" type="checkbox" v-model="config.takeout.inAdvance.activated">
          <label for="activateInAdvanceTakeout">{{$t("settings.activate_order_in_advance")}}</label>
        </div>
        <div class="columns" v-if="config.takeout.inAdvance.activated">
          <div class="column">
            <div class="group">
              <label>{{$t("settings.asap")}}</label>
              <select v-model="config.takeout.inAdvance.ASAP">
                <option :value="true">{{$t('yes')}}</option>
                <option :value="false">{{$t('no')}}</option>
              </select>
            </div>
            <div class="group" v-if="$store.state.loggedUser.isSuperAdmin">
              <label>{{$t('settings.future_dates')}}</label>
              <select v-model="config.takeout.inAdvance.futureDate">
                <option :value="true">{{$t('yes')}}</option>
                <option :value="false">{{$t('no')}}</option>
              </select>
            </div>
            <!--
            <div class="group" style="display: none;">
              <label>{{$t("settings.outside_open_hours")}}</label>
              <select v-model="config.takeout.inAdvance.outsideHours">
                <option :value="true" selected>{{$t('yes')}}</option>
                <option :value="false">{{$t('no')}}</option>
              </select>
            </div> -->
          </div>
          <div class="column">
            <div class="group">
              <label>{{$t("settings.interval")}}</label>
              <select v-model="config.takeout.inAdvance.intervalInMinutes">
                <option :value="minute" v-for="minute of [5,10,15,20,30]">{{minute}}</option>
              </select>
            </div>
            <div class="group">
              <label>{{$t("settings.orders_per_interval")}}</label>
              <input type="number" v-model="config.takeout.inAdvance.maxPerInterval">
            </div>
          </div>
        </div>
      </TabSection>
  
      <TabSection :title="$t('message')" v-if="config.takeout">
        <TipBox info>
          <span v-html="$t('tips.message.takeout')"></span>
        </TipBox>
        <div class="group">
          <LocalizedInput textarea :title="$t('settings.service_message')" :maxSize="200" :translate="config.takeout.onEnterMessage.message" />
        </div>
        <div class="group">
          <input id="chkPopupTakeout" type="checkbox" v-model="config.takeout.onEnterMessage.type" true-value="popup" :false-value="null">
          <label for="chkPopupTakeout">{{$t('settings.open_in_window')}}</label>
        </div>
      </TabSection>
  
      <TabSection :title="$t('notifications')" v-if="config.takeout">
        <TipsNotification />
        <div class="subtitle">
          <span class="flex-grow">{{$t("settings.on_sale_notification")}}</span>
        </div>
        <TipBox warning v-if="!isSMSactivated" no-border>
          <div v-html="$t('tips.sms_feature.disabled')"></div>
        </TipBox>
        <div class="group" :class="{locked: !isSMSactivated}">
          <label>{{$t("settings.sms_notification")}}</label>
          <VueSelect multiple v-model="config.takeout.notifications.onSale.sms" taggable>
            <span slot="no-options">{{$t("settings.sms_tip")}}</span>
          </VueSelect>
        </div>
        <div class="group">
          <label>{{$t("settings.email_notification")}}</label>
          <VueSelect multiple v-model="config.takeout.notifications.onSale.emails" taggable>
            <span slot="no-options">{{$t("settings.email_tip")}}</span>
          </VueSelect>
        </div>
      </TabSection>
  
      <!--
      <Panel :title="$t('settings.questions')">
        <template v-for="(question, qIndex) of config.takeout.questions">
          <div class="subtitle">
            <span class="flex-grow">{{$t("settings.question") + ' #' + (qIndex + 1)}}</span>
          </div>
          <LocalizedInput :translate="question" />
          <div class="question-options">
            <div class="group">
              <input :id="`tak_q_opt_${qIndex}`" type="checkbox" v-model="question.optional">
              <label :for="`tak_q_opt_${qIndex}`">{{$t("optional")}}</label>
            </div>
            <button class="btn btn-primary" @click="removeQuestion(qIndex)">X</button>
          </div>
        </template>
        <button class="btn btnAddQuestion btn-primary" @click="addQuestion">
          {{$t('settings.add_question')}}
          <svgicon src="/icon/add.svg" height="15" width="15"></svgicon>
        </button>
      </Panel>
      -->
    </Tabs>

    <div class="footer-actions" v-if="$store.getters.loggedUserHasModifyPermission">
      <button class="btn btn-primary" @click="$emit('save')">{{$t("save")}}</button>
    </div>

  </div>
</template>

<script>

  import Vue from 'vue';
  import Cascader from "@/resources/cascader";
  import DayTimeRange from '@/components/tools/DayTimeRange.vue';
  import VueSelect from 'vue-select';
  import LocalizedInput from "@/components/tools/LocalizedInput";
  import TipsNotification from "@/components/tips/TipsNotification.vue";
  import TipsOpenHours from "@/components/tips/TipsOpenHours.vue";
  import TipsInAdvance from "@/components/tips/TipsInAdvance.vue";

  export default {
    name: "SettingsTakeout",

    props: {
      config: Object,
      parentConfig: Object,
      parentValidate: Object,
      permissions: Object,
      currencySymbol: {
        type: String,
        default: '$'
      }
    },

    components: { VueSelect, DayTimeRange, LocalizedInput, TipsNotification, TipsOpenHours, TipsInAdvance },

    async mounted() {
      this.cascader = new Cascader(this.config, this.parentConfig);
    },

    data() {
      return {
        cascader: null
      }
    },

    computed: {
      isSMSactivated() {
        return this.$store.state.contextCompany && this.$store.state.contextCompany.smsActivated;
      }
    },

    watch: {
      "config.takeout.editOpenHours": function(edit, old) {
        if (old === undefined) {
          return;
        }
        if (edit) {
          Vue.set(this.config.takeout, "hours", this._copy(this.parentConfig.takeout.hours));
        } else {
          Vue.delete(this.config.takeout, "hours");
        }
        this.$forceUpdate();
      }
    },

    methods: {
      _copy(obj) {
        return JSON.parse(JSON.stringify(obj));
      },
      addQuestion() {
        this.config.takeout.questions.push({
          fr: null,
          en: null,
          optional: false
        })
      },
      removeQuestion(index) {
        this.config.takeout.questions.splice(index, 1)
      }
    }
  }
</script>

<style lang="scss" scoped>

  #settingsTakeout {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }

  .general {
    .subtitle {
      padding-top: 10px;
    }
  }

  #editOpenHoursContainerTakeout, #activateInAdvanceContainerTakeout {
    label {
      color: #404040;
      font-weight: bold;
      margin-bottom: 30px;
    }
  }
  .openHoursDisabled {
    opacity: 0.7;
    pointer-events: none;
  }
  input {
    width: 100%;
  }

  .question-options {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
  }

  .btnAddQuestion {
    display: flex;
    align-items: center;
    fill: white;
    .svgicon {
      margin-left: 10px;
    }
  }

</style>
